import {
  AUDIO_TYPE,
  DOCUMENT,
  IMAGE_TYPE,
  OFFICE_TYPE,
  PDF_TYPE,
  URL_TYPE
} from "@/modules/Document/constants/DocumentConstants";
import { DocumentDTO } from "@/modules/Document/models/DocumentDTO";
import { EmailData } from "@/modules/Email/models/EmailData";
import { EmailQuery } from "@/modules/Email/models/EmailQuery";
import { EmailService } from "@/modules/Email/services/EmailService";
import { EVENT_MESSAGES } from "@/modules/Events/constants/EventConstants";
import {
  NOTIFICATION_ACCESS,
  NOTIFICATION_CONFIG,
  NOTIFICATION_EVENTS,
  VALID_IMG_EXTENSIONS,
  WHATSAPP_DOCUMENT_CATEGORY
} from "@/modules/Notification/constants/NotificationConstants";
import { NotificationConfig } from "@/modules/Notification/models/NotificationConfig";
import { NotificationParams } from "@/modules/Notification/models/NotificationParams";
import { NotificationTemplate } from "@/modules/Notification/models/NotificationTemplate";
import { NotificationService } from "@/modules/Notification/services/NotificationService";
import {
  MULTIMEDIA_CLEANED,
  PARAMETER_CLEANED
} from "@/shared/components/MultimediaManager/constants/MultimediaManagerConstants";
import { MultimediaSelected } from "@/shared/components/MultimediaManager/models/MultimediaSelected.model";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import {
  COLLECTIONS_NAME,
  FORM_MESSAGES,
  FORM_VALIDATORS
} from "@/shared/constants/FormConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Http } from "@status/codes";
import { Component, Inject, Prop, Vue, Watch } from "vue-property-decorator";
import Vuetify from "vuetify";
import DocumentPickerModal from "../../../DocumentPickerModal/DocumentPickerModal.vue";
import { FieldChannels } from "../../model/FieldChannels";
import {
  MESSAGE_EVENTS,
  MESSAGE_PARAMETERS_NOT_FOUND,
  MESSAGE_TYPE,
  PARAMS_DATA_TYPES,
  UPDATE_PARAMS_LIST_EVENT
} from "./constants/MessageConfigurationConstants";
import MultimediaManager from "@/shared/components/MultimediaManager/MultimediaManager.vue";
import { NotificationTemplateServices } from "@/modules/NotificationTemplate/services/NotificationTemplateService";
import {
  DATE_LOCALE,
  GENERAL_CONSTANTS,
  STATE
} from "@/shared/constants/GeneralConstants";
import { NOTIFICATION_ACCESS as NOTIFICATION_ACCESS_TEMPLATE } from "@/modules/NotificationTemplate/constants/NotificationTemplateConstants";
import TimeSelection from "@/shared/components/TimeSelection/TimeSelection.vue";
import { ParameterConfig } from "@/modules/NotificationTemplate/models/parameter-config.model";
import lodash from "lodash";
import { LACK_OF_OPTIONS } from "@/modules/Dashboards/AdminDashboard/constants/AdminDashboardConstants";
import { AxiosError } from "axios";
import {
  LIST_ACCESS,
  LIST_CONSTANTS
} from "@/modules/List/constants/ListConstants";
import { List } from "@/shared/components/GenericSearchBar/model/List";
import { ListService } from "@/modules/List/services/ListService";
import { FormTemplateService } from "@/modules/FormTemplate/services/FormTemplateService";
import { FORMS_ACCESS } from "@/modules/Forms/constants/FormsConstants";
import { NotificationTemplateFilter } from "@/modules/NotificationTemplate/models/notification-template-filter.model";

Vue.use(Vuetify);

@Component({
  name: "MessageConfiguration",
  components: { DocumentPickerModal, MultimediaManager, TimeSelection }
})
export default class MessageConfiguration extends Vue {
  @Prop({ default: 0 }) reset!: number;
  @Prop({ default: false }) isEditing!: boolean;
  @Prop({ default: 0 }) editingEvent!: number;
  @Prop() updateMessage!: number;
  @Prop({ default: "" }) userId?: string;
  @Prop() paramsList!: NotificationParams[];
  @Prop() fields!: FieldChannels;
  @Prop({ default: false }) isDocument!: boolean;
  @Prop({ default: false }) isOnlyDocument!: boolean;
  @Prop() defaultDocument!: DocumentDTO;
  @Prop({ default: false }) isScheduledAvailable!: boolean;
  @Prop({ default: false }) canEditRestrictedField!: boolean;
  @Prop() notificationConfig!: NotificationConfig;
  @Prop({ default: false }) isMappingData!: boolean;
  @Prop({ default: "" }) selectedCollection!: string;
  @Prop({ default: [] }) formTemplates!: string[];
  @Prop() isOnline?: boolean;

  @Inject() notificationService!: NotificationService;
  @Inject() notificationTemplateService!: NotificationTemplateServices;
  @Inject() emailService!: EmailService;
  @Inject() listService!: ListService;
  @Inject() formTemplateService!: FormTemplateService;

  BODY_LABEL = NOTIFICATION_CONFIG.LABEL.BODY;
  WHATSAPP_TEMPLATE_LABEL = NOTIFICATION_CONFIG.LABEL.WHATSAPP_TEMPLATE;
  WHATSAPP_TEMPLATE_HINT = NOTIFICATION_CONFIG.HINT.WHATSAPP_TEMPLATE;
  WEBHOOK_LABEL = NOTIFICATION_CONFIG.LABEL.WEBHOOK;
  WEBHOOK_HINT = NOTIFICATION_CONFIG.HINT.WEBHOOK;
  FORM_FIELD_LABEL = NOTIFICATION_CONFIG.LABEL.FORM_FIELD;
  FORM_FIELD_HINT = NOTIFICATION_CONFIG.HINT.FORM_FIELD;
  TITLE_LABEL = NOTIFICATION_CONFIG.LABEL.TITLE;
  URL_LABEL = NOTIFICATION_CONFIG.LABEL.URL;
  URL_HINT = NOTIFICATION_CONFIG.HINT.URL;
  EMAIL_LABEL = NOTIFICATION_CONFIG.LABEL.EMAIL;
  VIDEO_LABEL = NOTIFICATION_CONFIG.LABEL.VIDEO;
  IMAGE_LABEL = NOTIFICATION_CONFIG.LABEL.IMAGE;
  FILE_LABEL = NOTIFICATION_CONFIG.LABEL.FILE;
  LATITUDE_LABEL = NOTIFICATION_CONFIG.LABEL.LATITUDE;
  LONGITUDE_LABEL = NOTIFICATION_CONFIG.LABEL.LONGITUDE;
  MSG_TEXT = NOTIFICATION_CONFIG.LABEL.MSG_TEXT;
  EXAMPLE_TEXT = NOTIFICATION_CONFIG.LABEL.EXAMPLE_TEXT;
  DOCUMENT_TEMPLATE_LABEL = NOTIFICATION_CONFIG.LABEL.DOCUMENT_TEMPLATE;
  PARAMS_DATA_TYPES = PARAMS_DATA_TYPES;
  FIELD_LABEL = NOTIFICATION_CONFIG.LABEL.FIELD_TEXT;
  CUSTOM_FIELD_LABEL = NOTIFICATION_CONFIG.LABEL.CUSTOM_FIELD_TEXT;
  LIST_FIELD_LABEL = NOTIFICATION_CONFIG.LABEL.LIST_FIELD_TEXT;

  regex = NOTIFICATION_CONFIG.REGEX_BODY;
  requiredField = [FORM_VALIDATORS.REQUIRED_FIELD];
  notBlankSpaces = [FORM_VALIDATORS.NOT_BLANK_SPACES_VALIDATOR];
  requiredObject = [FORM_VALIDATORS.REQUIRED_OBJECT];
  requiredArray = [FORM_VALIDATORS.REQUIRED_ARRAY];
  urlPattern = [FORM_VALIDATORS.URL_PATTERN];
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  textAreaClass = STYLE_CLASSES.TEXT_AREA;
  accentColor = STYLE_CLASSES.CHIP_COLOR.ACCENT;
  LOCALE = DATE_LOCALE;
  MESSAGE_TYPE = MESSAGE_TYPE;

  loadingMessage = false;
  title = "";
  body = "";
  bodyAux = "";
  originalBody = "";
  image: MultimediaSelected = { ...MULTIMEDIA_CLEANED };
  video: MultimediaSelected = { ...MULTIMEDIA_CLEANED };
  file = "";
  latitude = "";
  longitude = "";
  templateChosen: NotificationTemplate | string = "";
  templateName = "";
  emailChosen: EmailData | string = "";
  webhookChosen = "";
  formFieldChosen: string[] = [];
  documentPickerDialog = false;
  selectedDocuments: DocumentDTO[] = [];
  chosenWhatsappTemplate: NotificationTemplate = ("" as unknown) as NotificationTemplate;
  params: NotificationParams[] = [];
  paramsAux: any = {};
  paramsName: string[] = [];
  emailLastRef = "";
  emailDataList: EmailData[] = [];
  webhookList: List[] = [];
  formFieldsList: List[] = [];
  whatsappTemplates: NotificationTemplate[] = [];
  multimediaFile: MultimediaSelected = { ...MULTIMEDIA_CLEANED };
  currentTabParam = 0;
  paramsOptionGroup: number[] = [];
  menuFieldDateType = false;
  disableOptionList: boolean[] = [];
  MappingAux = false;

  templateRules = [FORM_VALIDATORS.REQUIRED_FIELD];
  messageRules = [
    FORM_VALIDATORS.REQUIRED_FIELD,
    FORM_VALIDATORS.NOT_BLANK_SPACES_VALIDATOR
  ];

  limitChar = -1;

  async mounted() {
    if (this.isOnlyDocument) {
      this.getDocumentTemplates();
    }
  }

  @Watch("notificationConfig.notification.channels")
  validateChannel() {
    const chanels = this.notificationConfig.notification.channels;
    if (chanels && chanels.length == 1) {
      this.freeTextValidationChannel(chanels[0]);
    } else {
      this.notificationConfig.notification.channels?.includes(
        NOTIFICATION_CONFIG.CHANNEL_TEXT.WHATSAPP
      ) && !this.isOnline
        ? (this.templateRules = [FORM_VALIDATORS.REQUIRED_FIELD])
        : [];
      this.messageRules = [
        FORM_VALIDATORS.REQUIRED_FIELD,
        FORM_VALIDATORS.NOT_BLANK_SPACES_VALIDATOR
      ];
      this.limitChar = -1;
    }
  }
  @Watch("notificationConfig.notification.message.type")
  async updatedMessageType() {
    await this.getDocumentTemplates();
  }

  @Watch("editingEvent")
  async editNotification() {
    if (this.isEditing) {
      this.loadingMessage = true;
      this.MappingAux = true;
      await this.mapNotificationData();
      this.$emit(NOTIFICATION_EVENTS.MAPPED.MESSAGE_CONFIGURATION);
      this.formatParams();
      this.MappingAux = false;
      this.loadingMessage = false;
    }
  }
  @Watch("isOnline")
  validateWhatsApp() {
    if (this.isOnline != undefined) {
      this.validateChannel();
    }
  }

  async getEmailById(id: string) {
    try {
      const emailResponse = await this.emailService.getEmailById(id);
      if (emailResponse.code === Http.Found && emailResponse.data) {
        this.emailChosen = emailResponse.data;
      } else {
        Snackbar.popError(emailResponse.message);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? DOCUMENT.MESSAGE.FORBIDDEN
          : EVENT_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  async loadWebhookList() {
    this.webhookList = await this.getListDataByName(
      LIST_CONSTANTS.WEBHOOK_LIST_NAME
    );
  }

  async getListDataByName(name: string) {
    try {
      const responseData = await this.listService.getListOptionsByName(name);
      if (responseData.code === Http.Found && responseData.data !== undefined) {
        const dataList = responseData.data;
        const finalListData: List[] = dataList.map(a => ({
          key: (a.id || a.value) as string,
          name: a.title
        }));
        return finalListData;
      } else {
        Snackbar.popInfo(LACK_OF_OPTIONS);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + LIST_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
    return [];
  }

  async getFormTemplateById() {
    this.formFieldsList = [];
    try {
      const response = await this.formTemplateService.getFormTempsByIdsArray({
        formTempsId: this.formTemplates
      });
      if (response.code === Http.Found && response.data) {
        const listOfFields: List[] = [];
        for (const formTemplate of response.data) {
          formTemplate.fields.map(field => {
            const fieldTitle = `${
              this.formTemplates.length > 1 ? formTemplate.name + " - " : ""
            }${field.schema.title || field.conversationTitle}`;
            listOfFields.push({
              key: field.key,
              name: fieldTitle
            });
          });
        }

        this.formFieldsList = listOfFields;
      } else {
        Snackbar.popInfo(response.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + FORMS_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async loadEmails() {
    try {
      const emailQuery: EmailQuery = {};
      if (this.emailLastRef !== "") {
        emailQuery.lastReference = this.emailLastRef;
      }
      const emailDataResponse = await this.emailService.getEmailListByFilter(
        emailQuery
      );

      if (emailDataResponse.code === Http.Found && emailDataResponse.data) {
        if (emailDataResponse.data.lastReference !== this.emailLastRef) {
          this.emailDataList = this.emailDataList.concat(
            emailDataResponse.data.emails
          );
          this.emailLastRef = emailDataResponse.data.lastReference;
        }
      } else {
        Snackbar.popInfo(DOCUMENT.MESSAGE.NO_MORE_DATA);
      }
    } catch (error) {
      if ((error as Error).message === "Request failed with status code 403") {
        Snackbar.popError(DOCUMENT.MESSAGE.FORBIDDEN);
      } else {
        Snackbar.popError(EVENT_MESSAGES.REQUEST_FAILED);
      }
    }
  }

  async getWhatsappTemplateByTempId(tempId: string) {
    try {
      const responseData = await this.notificationService.getWhatsappTemplateByTempId(
        tempId
      );
      if (responseData.code === Http.Found && responseData.data !== undefined) {
        this.templateChosen = responseData.data;
        this.paramsName = [
          ...new Set(
            ((this.templateChosen as NotificationTemplate).data || "").match(
              this.regex
            )
          )
        ];
        this.setParameterList();
      } else {
        Snackbar.popInfo(responseData.message);
        this.templateChosen = "";
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${NOTIFICATION_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  async getDocumentTemplates() {
    try {
      const filters: NotificationTemplateFilter = {
        graphs: "false",
        type: [this.notificationConfig.notification.message.type as string],
        state: STATE.ACTIVE
      };

      const channel = this.notificationConfig.notification.channelsKeys?.find(
        item => item.key == "whatsapp"
      )?.value;

      if (channel) {
        filters.channel = [channel];
      }

      if (this.isDocument) {
        filters.type = [];
        filters.category = [WHATSAPP_DOCUMENT_CATEGORY];
      }
      const responseData = await this.notificationTemplateService.filterTemplates(
        filters
      );

      if (responseData.code === Http.Found && responseData.data !== undefined) {
        this.whatsappTemplates = responseData.data.templates;
      } else {
        Snackbar.popInfo(responseData.message);
        this.whatsappTemplates = [];
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${NOTIFICATION_ACCESS_TEMPLATE.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  async getWhatsappTemplates() {
    if (
      this.notificationConfig.notification.channels &&
      this.notificationConfig.notification.channels.length > 0
    ) {
      const channel = this.notificationConfig.notification.channelsKeys?.find(
        item => item.key == "whatsapp"
      )?.value;
      try {
        this.whatsappTemplates = [];
        const filters: NotificationTemplateFilter = {
          type: [this.notificationConfig.notification.message.type as string],
          graphs: "false",
          category: [
            this.notificationConfig.notification.message.category as string
          ],
          state: STATE.ACTIVE
        };

        if (channel) {
          filters.channel = [channel];
        }

        const responseData = await this.notificationTemplateService.filterTemplates(
          filters
        );
        if (
          responseData.code === Http.Found &&
          responseData.data !== undefined
        ) {
          this.whatsappTemplates = responseData.data.templates;
        } else {
          Snackbar.popInfo(responseData.message);
          this.whatsappTemplates = [];
        }
      } catch (error) {
        const errorMessage =
          (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
            ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${NOTIFICATION_ACCESS_TEMPLATE.GET}`
            : FORM_MESSAGES.REQUEST_FAILED;

        Snackbar.popError(errorMessage);
      }
    }
  }

  documentParams() {
    if (this.isDocument) {
      if (this.isOnlyDocument) {
        if (this.selectedDocuments.length === 0)
          this.selectedDocuments.push(this.defaultDocument);
        this.documentSelected();
      } else {
        this.selectedDocuments = [];
      }
    }
  }

  @Watch("reset")
  async resetNotification() {
    if (!this.isMappingData) {
      if (this.isEditing) {
        await this.mapNotificationData();
      } else {
        this.clearNotificationData();
      }
    }
  }

  @Watch("fields", { deep: true })
  async updatedFields() {
    if (!this.isMappingData) {
      if (this.fields.emailFields) await this.loadEmails();

      if (this.fields.webhookFields) {
        await this.getFormTemplateById();
        await this.loadWebhookList();
      }
      this.templateChosen = "";
      this.emailChosen = "";
      this.paramsName = [];
      this.params = [];
      this.title = "";
      this.body = "";
      this.bodyAux = "";
      this.originalBody = "";
      if (this.isDocument) await this.getDocumentTemplates();
    }
  }

  @Watch("channelsChosen")
  resetTemplateChosen() {
    if (!this.isMappingData) {
      this.templateChosen = "";
    }
  }

  async mapNotificationData() {
    this.title = this.notificationConfig.notification.message.title ?? "";
    this.body = this.notificationConfig.notification.message.body ?? "";
    this.bodyAux = this.notificationConfig.notification.message.body ?? "";
    this.originalBody = this.notificationConfig.notification.message.body ?? "";
    this.multimediaFile = this.notificationConfig.notification.message
      .multimedia ?? { ...MULTIMEDIA_CLEANED };
    this.image = this.notificationConfig.notification.message.image ?? {
      ...MULTIMEDIA_CLEANED
    };
    this.video = this.notificationConfig.notification.message.video ?? {
      ...MULTIMEDIA_CLEANED
    };
    this.file = this.notificationConfig.notification.message.file ?? "";
    this.latitude = this.notificationConfig.notification.message.latitude ?? "";
    this.longitude =
      this.notificationConfig.notification.message.longitude ?? "";
    this.params = this.notificationConfig.notification.message.params ?? [];
    await this.getWhatsappTemplates();
    if (this.notificationConfig.notification.message.emailSender) {
      await this.loadEmails();
      const id = this.notificationConfig.notification.message
        .emailSender as string;
      await this.getEmailById(id ? id : "");
    }
    if (
      this.notificationConfig.notification.channels?.includes(
        NOTIFICATION_CONFIG.CHANNEL_TEXT.WEBHOOK
      )
    ) {
      await this.getFormTemplateById();
      await this.loadWebhookList();
    }
    this.webhookChosen =
      this.notificationConfig.notification.message.webhook || "";
    this.formFieldChosen =
      this.notificationConfig.notification.message.formFields || [];

    if (this.notificationConfig.notification.message.template) {
      const tempId = this.notificationConfig.notification.message
        .template as string;
      await this.getWhatsappTemplateByTempId(tempId ? tempId : "");
    }
  }

  clearNotificationData() {
    this.title = "";
    this.body = "";
    this.bodyAux = "";
    this.originalBody = "";
    this.multimediaFile = { ...MULTIMEDIA_CLEANED };
    this.image = { ...MULTIMEDIA_CLEANED };
    this.video = { ...MULTIMEDIA_CLEANED };
    this.file = "";
    this.latitude = "";
    this.longitude = "";
    this.templateChosen = "";
    this.selectedDocuments = [];
    this.params = lodash.cloneDeep(
      this.paramsName.map(() => PARAMETER_CLEANED)
    );
  }

  @Watch("paramsAux", { deep: true })
  handleParamsAux() {
    if (this.MappingAux) {
      return;
    }
    let originalBody = this.originalBody;
    const lengthParams =
      (this.templateChosen as NotificationTemplate).configParameters?.length ||
      0;
    for (let i = 0; i < lengthParams; i++) {
      if (this.paramsOptionGroup[i] == 1 && this.paramsAux[i]) {
        originalBody = originalBody.replace(`{{${i + 1}}}`, this.paramsAux[i]);
      } else if (
        this.paramsOptionGroup[i] == 0 &&
        this.paramsAux[i] &&
        this.paramsAux[i].name
      ) {
        originalBody = originalBody.replace(
          `{{${i + 1}}}`,
          `{${this.paramsAux[i].name}}`
        );
      }
    }
    this.bodyAux = originalBody;
  }
  @Watch("isDocument")
  async updateDocument() {
    this.body = "";
    this.bodyAux = "";
    this.originalBody = "";
    await this.getDocumentTemplates();
  }

  @Watch("title")
  updatedTitle() {
    if (!this.isMappingData) {
      this.$emit(MESSAGE_EVENTS.UPDATED.TITLE, this.title);
    }
  }

  @Watch("body")
  updatedBody() {
    if (!this.isMappingData) {
      this.$emit(MESSAGE_EVENTS.UPDATED.BODY, this.body);
    }
  }

  @Watch("image")
  updatedImage() {
    const extension = (this.image.fieldName ?? "").split(".").pop() ?? "";
    if (
      this.image.name != "" &&
      this.notificationConfig.notification.channels?.includes(
        NOTIFICATION_CONFIG.CHANNEL_TEXT.WHATSAPP
      ) &&
      !VALID_IMG_EXTENSIONS.includes(extension)
    ) {
      this.image = { ...MULTIMEDIA_CLEANED };
      Snackbar.popError(NOTIFICATION_CONFIG.ERRORS.INVALID_IMG_FORMAT);
      return;
    }
    if (!this.isMappingData) {
      this.$emit(MESSAGE_EVENTS.UPDATED.IMAGE, this.image);
    }
  }

  changeParams(index: number) {
    this.params[index] = this.paramsAux[index];
    this.paramSelected();
  }

  getFile(fileSelected: MultimediaSelected) {
    this.multimediaFile = fileSelected;
    this.$emit(MESSAGE_EVENTS.UPDATED.MULTIMEDIA, this.multimediaFile);
  }

  getFileParameter(fileSelected: MultimediaSelected, index: number) {
    Vue.set(this.params, index, {
      ...fileSelected,
      id: fileSelected.multimediaPath!,
      editable: true
    });
    const paramsAux = { ...this.paramsAux };
    paramsAux[index] = `{${fileSelected.name}}`;
    this.paramsAux = paramsAux;
  }

  getMultimediaFile(fileSelected: MultimediaSelected) {
    switch (this.notificationConfig.notification.message.type) {
      case MESSAGE_TYPE.IMAGE:
        this.image = fileSelected;
        break;
      case MESSAGE_TYPE.VIDEO:
        this.video = fileSelected;
        break;
    }
  }

  @Watch("video")
  updatedVideo() {
    if (!this.isMappingData) {
      this.$emit(MESSAGE_EVENTS.UPDATED.VIDEO, this.video);
    }
  }

  @Watch("file")
  updatedFile() {
    if (!this.isMappingData) {
      this.$emit(MESSAGE_EVENTS.UPDATED.FILE, this.file);
    }
  }

  @Watch("latitude")
  updatedLatitude() {
    if (!this.isMappingData) {
      this.$emit(MESSAGE_EVENTS.UPDATED.LATITUDE, this.latitude);
    }
  }

  @Watch("longitude")
  updatedLongitude() {
    if (!this.isMappingData) {
      this.$emit(MESSAGE_EVENTS.UPDATED.LONGITUDE, this.longitude);
    }
  }

  @Watch("templateChosen", { deep: true })
  getTemplate() {
    if (!this.isMappingData) {
      if (this.templateChosen && this.templateChosen !== "") {
        this.templateName = (this
          .templateChosen as NotificationTemplate).elementName;
        this.paramsName = [
          ...new Set(
            ((this.templateChosen as NotificationTemplate).data || "").match(
              this.regex
            )
          )
        ];
        this.params = lodash.cloneDeep(
          this.paramsName.map(() => PARAMETER_CLEANED)
        );
        this.setParameterList();
        this.body = (this.templateChosen as NotificationTemplate).data;
        this.bodyAux = (this.templateChosen as NotificationTemplate).data;
        this.originalBody = (this.templateChosen as NotificationTemplate).data;
        this.documentParams();
        this.$emit(MESSAGE_EVENTS.UPDATED.TEMPLATE, this.templateChosen);
        this.currentTabParam = 0;
        this.verifyIfMustSendButtonParams();
      } else {
        this.body = "";
        this.bodyAux = "";
        this.originalBody = "";
        this.paramsName = [];
        this.templateName = "";
        this.paramsOptionGroup = [];
        this.resetTemplateChosen();
        this.$emit(MESSAGE_EVENTS.UPDATED.TEMPLATE, this.templateName);
      }
    }
  }

  verifyIfMustSendButtonParams() {
    if (
      this.defaultDocument?.documentPath &&
      (this.templateChosen as NotificationTemplate).appCategory?.includes(
        "DOCUMENTOS"
      )
    ) {
      const documentId = this.defaultDocument?.documentPath.split("/").pop();
      this.$emit(MESSAGE_EVENTS.UPDATED.BUTTON_PARAMS, documentId);
    }
  }

  escapeRegex(str: string) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  @Watch("emailChosen")
  updatedEmail() {
    if (!this.isMappingData) {
      this.$emit(MESSAGE_EVENTS.UPDATED.EMAIL, this.emailChosen);
    }
  }

  @Watch("webhookChosen")
  updatedWebhook() {
    if (!this.isMappingData) {
      this.$emit(MESSAGE_EVENTS.UPDATED.WEBHOOK, this.webhookChosen);
    }
  }
  @Watch("formFieldChosen")
  updatedFormFields() {
    if (!this.isMappingData) {
      this.$emit(MESSAGE_EVENTS.UPDATED.FORM_FIELDS, this.formFieldChosen);
    }
  }

  @Watch("params", { deep: true })
  paramSelected() {
    if (this.defaultDocument?.documentPath != undefined) {
      const multimediaManagerImage = {
        _key: this.defaultDocument._key,
        category: this.defaultDocument.category.subCategory,
        id: this.defaultDocument.documentPath,
        name: this.defaultDocument.fileName,
        fieldName: this.defaultDocument.fileName,
        multimediaPath: this.defaultDocument.documentPath,
        type: this.defaultDocument.type,
        editable: true
      };
      this.params.forEach((param, index) => {
        if (
          param.type === URL_TYPE ||
          param.type === AUDIO_TYPE ||
          param.type === PDF_TYPE ||
          param.type === IMAGE_TYPE ||
          param.type === OFFICE_TYPE ||
          param.id === URL_TYPE ||
          param.id === AUDIO_TYPE ||
          param.id === PDF_TYPE ||
          param.id === IMAGE_TYPE ||
          param.id === OFFICE_TYPE
        ) {
          multimediaManagerImage.type = URL_TYPE;
          multimediaManagerImage.editable = param.editable;
          this.params[index] = multimediaManagerImage;
        }
      });
      this.$emit(
        MESSAGE_EVENTS.UPDATED.PARAMS,
        this.params,
        this.paramsName.length
      );
      return;
    }
    if (!this.isMappingData) {
      this.$emit(
        MESSAGE_EVENTS.UPDATED.PARAMS,
        this.params,
        this.paramsName.length
      );
    }
  }

  documentSelected() {
    if (!this.isMappingData) {
      const url = this.getDocumentUrlData();
      this.params[this.paramsName.length - 1] = {
        name: url,
        id: "url",
        editable: true
      };
    }
  }

  @Watch("updateMessage")
  async updatedMessage() {
    if (!this.isMappingData) {
      if (this.loadingMessage === false) {
        if (this.isDocument) {
          await this.getDocumentTemplates();
        } else {
          await this.getWhatsappTemplates();
        }
      }
    }
  }

  getDocumentUrlData(): string {
    let urlParam = "";
    this.selectedDocuments.forEach((document: DocumentDTO) => {
      urlParam = `${urlParam}${document.documentPath}, `;
    });
    return `${urlParam.slice(0, -2)}.` as string;
  }

  openDocumentPicker() {
    this.documentPickerDialog = true;
  }

  addDocument(document: DocumentDTO) {
    this.selectedDocuments.push(document);
  }

  deleteDocument(index: number) {
    this.selectedDocuments.splice(index, 1);
  }

  filesChosen(selectedDocuments: DocumentDTO[]) {
    this.documentPickerDialog = false;
    this.selectedDocuments = selectedDocuments;
  }

  closeDocumentModal() {
    this.documentPickerDialog = false;
  }

  updatedParamCustom(value: string, index: number) {
    this.params[index] = {
      id: value,
      name: "",
      editable: true
    };
    const paramsAux = { ...this.paramsAux };
    paramsAux[index] = value;
    this.paramsAux = paramsAux;
    this.paramSelected();
  }

  handleInputSms() {
    this.notificationConfig.notification.message.body = this.bodyAux;
  }

  setParameterList() {
    const newParamsList: (
      | {
          collection: string | undefined;
          name: string;
          id: string;
          editable: boolean;
        }[]
      | undefined
    )[] = [];
    const configParameters = (this.templateChosen as NotificationTemplate)
      .configParameters;
    if (!configParameters || configParameters.length == 0) {
      Snackbar.popInfo(MESSAGE_PARAMETERS_NOT_FOUND);
    } else {
      configParameters.forEach((parameter: ParameterConfig, index: number) => {
        this.disableOptionList[index] =
          parameter.fields?.length == 0 ? true : false;
        Vue.set(
          this.paramsOptionGroup,
          index,
          Number(this.disableOptionList[index])
        );
        if (
          this.selectedCollection == "" &&
          parameter.collection != COLLECTIONS_NAME.USER.toLowerCase()
        ) {
          Vue.set(this.paramsOptionGroup, index, 1);
          this.disableOptionList[index] = true;
          return;
        }
        newParamsList[index] = parameter.fields?.map(
          (e: NotificationParams) => {
            return {
              ...e,
              collection: parameter.collection
            };
          }
        );
      });
    }
    this.$emit(UPDATE_PARAMS_LIST_EVENT, newParamsList);
  }

  setShareDocParams() {
    const fields = [
      ...((this.templateChosen as NotificationTemplate).configParameters ?? [])
    ];

    if (fields.length == 0) {
      return;
    }

    fields.reverse();

    const multimediaField = fields.findIndex(
      field => field.type == PARAMS_DATA_TYPES.MULTIMEDIA
    );
    const lastStringField = fields.findIndex(
      field => field.type == PARAMS_DATA_TYPES.STRING
    );

    if (multimediaField == -1 && lastStringField > -1) {
      this.paramsAux[
        this.params.length - lastStringField - 1
      ] = this.getDocumentUrlData();
    } else if (multimediaField > -1) {
      this.paramsAux[
        this.params.length - multimediaField - 1
      ] = this.getDocumentUrlData();
    }
  }

  freeTextValidationChannel(channel: string) {
    switch (channel) {
      case NOTIFICATION_CONFIG.CHANNEL_TEXT.WHATSAPP: {
        this.messageRules = [
          FORM_VALIDATORS.REQUIRED_FIELD,
          FORM_VALIDATORS.NOT_BLANK_SPACES_VALIDATOR
        ];
        this.templateRules = this.isOnline
          ? []
          : [FORM_VALIDATORS.REQUIRED_FIELD];
        this.limitChar = -1;
        break;
      }
      case NOTIFICATION_CONFIG.CHANNEL_TEXT.SMS: {
        this.messageRules = [
          FORM_VALIDATORS.REQUIRED_FIELD,
          FORM_VALIDATORS.NOT_BLANK_SPACES_VALIDATOR,
          FORM_VALIDATORS.SMS_LIMIT
        ];
        this.templateRules = [];
        this.limitChar = 160;
        break;
      }
      case NOTIFICATION_CONFIG.CHANNEL_TEXT.PUSH: {
        this.messageRules = [
          FORM_VALIDATORS.REQUIRED_FIELD,
          FORM_VALIDATORS.NOT_BLANK_SPACES_VALIDATOR
        ];
        this.templateRules = [];
        this.limitChar = 250;
        break;
      }
      case NOTIFICATION_CONFIG.CHANNEL_TEXT.EMAIL: {
        this.messageRules = [
          FORM_VALIDATORS.REQUIRED_FIELD,
          FORM_VALIDATORS.NOT_BLANK_SPACES_VALIDATOR
        ];
        this.templateRules = [];
        this.limitChar = -1;
        break;
      }
      case NOTIFICATION_CONFIG.CHANNEL_TEXT.WEBHOOK: {
        this.messageRules = [
          FORM_VALIDATORS.REQUIRED_FIELD,
          FORM_VALIDATORS.NOT_BLANK_SPACES_VALIDATOR
        ];
        this.templateRules = [];
        this.limitChar = -1;
        break;
      }
    }
  }
  formatParams() {
    const templateParams =
      (this.templateChosen as NotificationTemplate).configParameters ?? [];
    this.params.forEach((param, index) => {
      const collection = param.collection && param.collection != "";
      if (
        this.templateChosen == "" ||
        (templateParams.length > 0 &&
          templateParams[index].type != PARAMS_DATA_TYPES.MULTIMEDIA)
      ) {
        this.paramsAux[index] = collection ? param : param.id;
        this.paramsOptionGroup[index] = collection ? 0 : 1;
      }
    });
  }

  changeFieldType(index: number) {
    const collection =
      this.params[index].collection && this.params[index].collection != "";
    if (this.paramsOptionGroup[index] == 1) {
      this.paramsAux[index] = collection ? "" : this.params[index].id;
    } else {
      this.paramsAux[index] = collection ? this.params[index] : "";
    }
  }
}
